module.exports = __webpack_public_path__ + "img/专利证书02_Smart-CMS数字城市智慧决策平台v1.0.9b6740b1.png";